import type { InstanceStore, InstanceStoreContent } from './instance-store.types';

/**
 * Creates a Svelte store for managing the instance state.
 * @returns An object containing the instance's content and methods to manipulate it.
 */
export function createInstanceStore(): InstanceStore {
  const state = $state<InstanceStoreContent>({ listeners: {} });

  return {
    on: (key: string, onmessage: (event: MessageEvent) => void) => {
      state.listeners[key] = onmessage;
    },
    set: (bc: BroadcastChannel) => {
      state.bc = bc;

      bc.onmessage = (e) => {
        if (e.data && typeof e.data === 'object' && typeof e.data?.key === 'string') {
          const { key, data } = e.data;
          const message = data ? JSON.parse(data) : {};
          // console.log('onmessage', e, e.data, key, message, state.listeners);
          state.listeners[key](message);
        }
      };
    },
    post: (key: string, message: object) => {
      if (state.bc) {
        // console.log('posting message', key, message);
        state.bc.postMessage({ key, data: JSON.stringify(message) });
      }
    }
  };
}
